<!--<pre>npwpInfoControl.valid: {{ npwpInfoControl.valid }}</pre>-->
<app-card-verification-form
  [isLoading]="isLoading"
  [title]="'Informasi NPWP'"
  [bodyData]="npwpInfoSubject.value"
  [status]="getVerifiedStatus(detailSubject.value && detailSubject.value.npwp_information)"
  [typeSection]="EnumCardVerificationSection.NPWP_INFORMATION"
  [type]="EnumCardVerificationForm.ASIDE_DOCUMENT"
  [sessionKey]="REVISION_SESSION.REGISTRATION_FINANCE"
  [cardNoteValue]="noteValue(EnumCardVerificationSection.NPWP_INFORMATION)"
  (cardNoteChanged)="onNoteChanges($event)"
  (afterActionVerification)="afterActionVerification($event)"
/>

<!--<pre>documentsControl.valid: {{ documentsControl.valid }}</pre>-->
<app-card-verification-form
  [isLoading]="isLoading"
  [title]="'Dokumen'"
  [bodyData]="documentSubject.value"
  [status]="getVerifiedStatus(detailSubject.value && detailSubject.value.documents)"
  [typeSection]="EnumCardVerificationSection.NPWP_DOCUMENT"
  [type]="EnumCardVerificationForm.DOCUMENT"
  [sessionKey]="REVISION_SESSION.REGISTRATION_FINANCE"
  [cardNoteValue]="noteValue(EnumCardVerificationSection.NPWP_DOCUMENT)"
  (cardNoteChanged)="onNoteChanges($event)"
  (afterActionVerification)="afterActionVerification($event)"
/>

<ng-container *ngIf="showButtonConfirm()">
  <div class="d-flex justify-content-end align-items-center mt-8 mb-20">
    <button mat-button color="primary" class="btn btn-primary btn-lg text-white" (click)="modalConfirm.open()" [disabled]="!npwpForm.valid">
      <span>Konfirmasi NPWP</span>
    </button>
  </div>
</ng-container>

<app-modal #modalConfirm [modalConfig]="modalConfigConfirm" [modalOptions]="{ size: 'lg' }">
  <div class="mb-n6">
    <app-note-view
      [classNoteView]="'mb-6'"
      [color]="'info'"
      [icon]="STRING_CONSTANTS.ICON.IC_INFORMATION"
      [text]="'Setelah dikonfirmasi, data NPWP tidak bisa diedit lagi.'"
      *ngIf="!hasRevisionNote()"
    />

    <p>Apakah anda yakin mengonfirmasi NPWP Distributor:</p>

    <div class="my-4" *ngIf="detailHeader as detail">
      <div class="row mb-4">
        <div class="col-12 col-md-4"><span class="text-gray-700">Nama Distributor</span></div>
        <div class="col-12 col-md-8">
          <span class="text-gray-700 me-2">:</span> <span>{{ detail.business_name ?? '-' }}</span>
        </div>
      </div>
      <div class="row mb-4 text-capitalize">
        <div class="col-12 col-md-4"><span class="text-gray-700">Cakupan</span></div>
        <div class="col-12 col-md-8">
          <span class="text-gray-700 me-2">:</span> <span>{{ detail.sales_area ?? '-' }}, {{ detail.sales_sub_area ?? '-' }}</span>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-12 col-md-4"><span class="text-gray-700">Regional Head</span></div>
        <div class="col-12 col-md-8">
          <span class="text-gray-700 me-2">:</span> <span>{{ detail.regional_head_name ?? '-' }}</span>
        </div>
      </div>
    </div>

    <ng-container *ngIf="hasRevisionNote(); else defaultTextTpl">
      <p class="mt-8">
        <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_DANGER" class="svg-icon svg-icon-1 me-2"></span>
        <strong>Catatan Perbaikan</strong>
      </p>

      <div class="row mb-4" *ngFor="let rev of getRevisionDataBody()">
        <div class="col-12 col-md-4">
          <span class="text-gray-700">{{ rev.label }}</span>
        </div>
        <div class="col-12 col-md-8">
          <span class="text-gray-700 me-2">:</span>
          <span>{{ rev.value }}</span>
        </div>
      </div>
    </ng-container>

    <ng-template #defaultTextTpl>
      <p class="mb-0">Data distributor yang dikonfirmasi akan berubah menjadi <strong>terverifikasi</strong>. Pastikan semua data telah lengkap dan benar.</p>
    </ng-template>
  </div>
</app-modal>

<app-modal #modalResponse [modalConfig]="modalConfigResponse" [modalOptions]="{ size: 'md' }">
  <div class="d-flex flex-column justify-content-center align-items-center mb-n6">
    <ng-container *ngIf="loadingSubmit | async; else responseTpl">
      <div class="mt-8">
        <mat-spinner></mat-spinner>
      </div>
    </ng-container>
    <ng-template #responseTpl>
      <span [inlineSVG]="STRING_CONSTANTS.ICON.SUCCESS_ALERT"></span>
      <div class="d-flex flex-column w-100 text-center mt-4">
        <ng-container *ngIf="hasRevisionNote(); else defaultTextTpl">
          <span>Distributor berhasil dikonfirmasi.</span>
          <span>Catatan perbaikan & Data Distributor dikembalikan ke Regional Head.</span>
        </ng-container>
        <ng-template #defaultTextTpl>
          <span>NPWP Distributor dikonfirmasi dan Distributor berhasil diverifikasi.</span>
        </ng-template>
      </div>
    </ng-template>
  </div>
</app-modal>
